import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const StockInvestmentExecSummary = ({ investorResult, yearlyData, params }) => {
  if (!investorResult || !yearlyData || !params) {
    return <div className="text-center text-gray-500">No data available.</div>;
  }

  const finalYear = yearlyData[yearlyData.length - 1];

  return (
    <div className="bg-blue-50 p-6 rounded-lg text-sm text-gray-800 leading-relaxed space-y-4">
      <h3 className="text-lg font-bold text-blue-900">Executive Summary: Stock Growth Model</h3>

      <p>
        This <strong>Stock Investment</strong> simulation projects the value of a one-time investment of <strong>{formatCurrency(params.propertyValue)}</strong>
        over a {params.termYears}-year period, assuming a consistent annual stock market growth rate of <strong>{params.stockGrowthRate}%</strong>.
      </p>

      <p>
        The model assumes no additional contributions or withdrawals during the term. All gains are driven purely by compounding capital appreciation,
        making it a clean benchmark for passive equity investment performance.
      </p>

      <h4 className="font-semibold text-blue-800">📈 Key Performance Highlights</h4>
      <ul className="list-disc list-inside space-y-1">
        <li>Total Term: <strong>{params.termYears} years</strong></li>
        <li>Initial Investment: <strong>{formatCurrency(params.propertyValue)}</strong></li>
        <li>Annual Growth Rate: <strong>{params.stockGrowthRate}%</strong></li>
        <li>Final Portfolio Value: <strong>{formatCurrency(finalYear.stockValue)}</strong></li>
        <li>Net Appreciation: <strong>{formatCurrency(investorResult.assetAppreciation)}</strong></li>
        <li>Total ROI: <strong>{investorResult.totalROI}%</strong></li>
        <li>Annualized ROI: <strong>{investorResult.annualizedROI}%</strong></li>
        <li>IRR Estimate: <strong>{investorResult.irrEstimate}%</strong></li>
      </ul>

      <p>
        While this model reflects a passive growth-only strategy, it offers a powerful illustration of long-term market compounding without any reinvestment risk,
        leverage, or operational overhead. It is ideal for comparison against more complex asset models like real estate or hybrid RTO+Gold portfolios.
      </p>
    </div>
  );
};

export default StockInvestmentExecSummary;
